import src from "IMAGE";
export default { src, width: 1091, height: 1342, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
